export const SAVE_ALL_PART_STOCKS = 'SAVE_ALL_PART_STOCKS'